module.exports = __webpack_public_path__ + "static/media/Athelas-Regular.83521bc5.svg";